import {
  Timer,
  PersonSimpleTaiChi,
  BellSimpleRinging,
  ChartLineUp,
  SignIn,
  Medal,
} from "@phosphor-icons/react";
import Reveal from "@/components/landing/Reveal";
import { useI18n } from "@/lib/i18n";

const ICONS = {
  Timer,
  PersonSimpleTaiChi,
  BellSimpleRinging,
  ChartLineUp,
  SignIn,
  Medal,
};

export default function Features() {
  const { t } = useI18n();
  const items = t("features.items") || [];
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 sm:py-32 bg-stone-100/60 dark:bg-neutral-950/50"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-emerald-800 dark:text-emerald-400">
              {t("features.kicker")}
            </div>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight text-balance text-neutral-900 dark:text-neutral-50">
              {t("features.h2Pre")}{" "}
              <span className="text-emerald-800 dark:text-emerald-400">
                {t("features.h2Highlight")}
              </span>
            </h2>
            <p className="mt-5 text-lg text-neutral-600 dark:text-neutral-300 leading-relaxed">
              {t("features.lead")}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6 auto-rows-fr">
          {items.map((f, i) => {
            const Icon = ICONS[f.icon] || Timer;
            return (
              <Reveal key={f.id} delay={i * 0.05} className={`${f.span} h-full`}>
                <article
                  data-testid={`feature-card-${f.id}`}
                  className="group relative h-full rounded-3xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 p-7 sm:p-8 transition-all hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(6,95,70,0.25)] flex flex-col"
                >
                  <div
                    className={`h-12 w-12 rounded-2xl inline-flex items-center justify-center shrink-0 ${
                      f.accent === "warm"
                        ? "bg-orange-500/10 text-orange-500"
                        : f.accent === "neutral"
                        ? "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200"
                        : "bg-emerald-800/10 dark:bg-emerald-400/10 text-emerald-800 dark:text-emerald-400"
                    }`}
                  >
                    <Icon size={24} weight="duotone" />
                  </div>

                  <h3 className="mt-6 font-display font-semibold text-xl sm:text-2xl text-neutral-900 dark:text-neutral-50 leading-snug">
                    {f.title}
                  </h3>
                  <p className="mt-3 text-[15px] text-neutral-600 dark:text-neutral-400 leading-relaxed">
                    {f.description}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
